import { useEffect, useState } from "react";
import breakpoints from "app/pages/.styles/export.scss";

export const useDeviceType = () => {
	const MOBILE_MAX = parseInt(breakpoints.sm, 10) || 768;
	const TABLET_MAX = parseInt(breakpoints.md, 10) || 1024;

	const getDeviceState = () => {
		const width = window.innerWidth;

		return {
			isMobile: width < MOBILE_MAX,
			isTablet: width >= MOBILE_MAX && width < TABLET_MAX,
			isDesktop: width >= TABLET_MAX,
		};
	};

	const [device, setDevice] = useState(() =>
		typeof window !== "undefined"
			? getDeviceState()
			: { isMobile: false, isTablet: false, isDesktop: true }
	);

	useEffect(() => {
		if (typeof window === "undefined") {
			return;
		}

		const handleResize = () => setDevice(getDeviceState());

		window.addEventListener("resize", handleResize);

		// eslint-disable-next-line consistent-return
		return () => window.removeEventListener("resize", handleResize);
	}, [MOBILE_MAX, TABLET_MAX]);

	return device;
};
